import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'components/Atoms/Icon/Icon';
import { ResidentCustomPublicationConsent } from 'types/publishedAssets';
import { SignupDisclaimer } from './SignupDisclaimer';
import styles from './NotificationSignup.module.scss';

interface Props {
  consents?: ResidentCustomPublicationConsent[];
}

// State B — authenticated resident already on every configured list.
// Read-only confirmation; no interactive controls.
export function AlreadySubscribed({ consents }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.noticeBox}>
        <Icon name="info" />
        <p>{t('notificationSignup.alreadySubscribed')}</p>
      </div>
      <SignupDisclaimer html={t('notificationSignup.authDisclaimer')} consents={consents} />
    </>
  );
}
